import {ConstraintsBuilderInterface} from './constraints-builder-interface';
import {SimplexConstraintsBuilder} from './simplex-constraints-builder';

const Factory = {
    getBuilder(): ConstraintsBuilderInterface {
        return new SimplexConstraintsBuilder();
    },
};

export {Factory};
